module.exports = __webpack_public_path__ + "static/media/eye.ef6b6287.svg";